var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.selectedContents.length)?_c('base-button',{attrs:{"type":"primary","size":"sm"},nativeOn:{"click":function($event){return _vm.$emit('delete')}}},[_vm._v(_vm._s(_vm.$tc( 'knowledge.search.delete-definitively', this.selectedContents.length, { count: this.selectedContents.length }, ))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }